import { apiClient } from '@/shared/services/client'
import type {
  ConfiguracionAnalyticsDifare,
  ConfiguracionAnalyticsDifareUpdateInput,
  DependientesFiltro,
  DependientesReporte,
  FaseAnalyticsDifare,
  OverviewAnalyticsDifare,
  PuntoVentaAnalyticsDifare,
  QuizProductoAnalyticsDifare,
  TestConnectionInput,
  TestConnectionResult,
  TriviaReporte,
  VisitadorAnalyticsDifare,
} from '../types'

const CONFIG_URL = '/analytics-difare/config'
const REPORTES_URL = '/analytics-difare/reportes'

export const analyticsDifareApi = {
  getConfiguracion: async () => {
    const { data } = await apiClient.get<ConfiguracionAnalyticsDifare>(`${CONFIG_URL}/`)
    return data
  },

  saveConfiguracion: async (payload: ConfiguracionAnalyticsDifareUpdateInput) => {
    const { data } = await apiClient.put<ConfiguracionAnalyticsDifare>(`${CONFIG_URL}/`, payload)
    return data
  },

  testConnection: async (payload?: TestConnectionInput) => {
    const { data } = await apiClient.post<TestConnectionResult>(
      `${CONFIG_URL}/test-connection`,
      payload ?? {},
    )
    return data
  },

  getOverview: async () => {
    const { data } = await apiClient.get<OverviewAnalyticsDifare>(`${REPORTES_URL}/overview`)
    return data
  },

  getVisitadores: async () => {
    const { data } = await apiClient.get<VisitadorAnalyticsDifare[]>(`${REPORTES_URL}/visitadores`)
    return data
  },

  getQuizzes: async () => {
    const { data } = await apiClient.get<QuizProductoAnalyticsDifare[]>(`${REPORTES_URL}/quizzes`)
    return data
  },

  getPuntosVenta: async () => {
    const { data } = await apiClient.get<PuntoVentaAnalyticsDifare[]>(`${REPORTES_URL}/puntos-venta`)
    return data
  },

  getFases: async () => {
    const { data } = await apiClient.get<FaseAnalyticsDifare[]>(`${REPORTES_URL}/fases`)
    return data
  },

  getDependientes: async (filtro: DependientesFiltro = {}) => {
    const { data } = await apiClient.get<DependientesReporte>(`${REPORTES_URL}/dependientes`, {
      params: filtro,
    })
    return data
  },

  getTrivias: async (params: { fase?: number } = {}) => {
    const { data } = await apiClient.get<TriviaReporte>(`${REPORTES_URL}/trivias`, { params })
    return data
  },
}
